export class Person {
  email: string = "";
  fullName: string = "";
  phoneNumber: string = "";
  aliasNames: AliasName[];
  organisation: string = "";
  positionAssignments: PositionAssignment[] = [];
  permissions: string[] = [];
  lastActivity: any = {};
  name: string = "";
  state: number = 0;
  id: string = "00000000-0000-0000-0000-000000000000";
  timeString: Date = new Date();
  profileImageUrl: string = null;
  associatedAccounts: AssociatedAccount[] = [];
  passwordUpdateTime?: Date = new Date();
  resetPassword?: ResetPassword = new ResetPassword();
  twoFactorAuthenticationEnabled: boolean;
}

export class PersonForm extends Person {

}

export class AssociatedAccount {
  oAuthProviderId: string = "00000000-0000-0000-0000-000000000000";
  subjectId: string = "";
}

export class AliasName {
  name: string = "";
  fullName: string = "";
}

export class PositionAssignment {
  locationId: string = "";
  positionId: string = "";
  activelyAssigned?: boolean = false;
  assignedSince?: Date = new Date();
  activelyAssignedSince?: Date = new Date();
  handedOverBy?: string = "";
  handedOverByName?: string = "";
  switchedBy?: string = "";
  switchedByName?: string = "";
}

export class PersonShort {
  fullName: string = "";
  state: number = 0;
  name: string = "";
  id: string = "00000000-0000-0000-0000-000000000000";
}

export class PersonProfileImage {
  image?: string = "00000000-0000-0000-0000-000000000000";
}

export class ResetPassword {
  resetLink?: string = null;
  validFor?: Date = null;
  initiatedBy?: string = "00000000-0000-0000-0000-000000000000";
  lastResetDate?: Date = null;
  lastResetInitiatedBy?: string = "00000000-0000-0000-0000-000000000000";
}

export enum State {
  Active = 0,
  Deactivated = 1,
  Removed = 2
}